/**
 * Returns a function to pick a property from an object
 * @param {string|function(*): any} fn - either the name of the property to pick or a function to extract it
 * @returns {(function(*): *)|*} a function that picks the property
 */
export function pick(fn) {
    return typeof fn === "string" ? (v) => Object.get(v, fn) : fn
}
